import ContactAndFooter from '../../ContactAndFooter/ContactAndFooter';
import Demo from '../../Demo/Demo';
import './About.css'
import GlobalPromise from "./GlobalPromise/GlobalPromise";
import Hero from "./Hero/Hero";
import HowClybourneWorks from "./HowClybourneWorks/HowClybourneWorks";
import MeetVisionaries from "./MeetVisionaries/MeetVisionaries";
import TrustedByLeaders from './TrustedByLeaders/TrustedByLeaders';
import WhyChooseClybourne from "./WhyChooseClybourne/WhyChooseClybourne";
import { useEffect } from 'react';
function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Demo />
      <Hero />
      <WhyChooseClybourne />
      <GlobalPromise />
      <MeetVisionaries />
      <HowClybourneWorks />
      <TrustedByLeaders />
      <ContactAndFooter />
    </>
  );
}

export default About;
